import Util from '../utils/util';
import Element from '../components/Element';

/**
 * 编辑控制器
 */
export default class TopoEditor extends Element {
    /**
     * 构造方法
     * @returns {undefined}
     */
    constructor(options) {
        super(options);

        /**
         * 编辑结束时的回调函数
         * @type {function}
         */
        this.onFinish = this.options.onFinish || null;

        /**
         * 激活的工具
         * @type {object}
         */
        this.activeTool = null;

        /**
         * 工具别名与工具构造器类的映射关系图
         * @type {object<toolKey, toolConstructor>}
         * */
        this._toolMap = {};

        // 0：ready；1.active；2:running；3:stopped
        this._status = 0;
    }

    /**
     * 添加到地图中
     * @param {Object}  map 地图对象
     */
    addTo(map) {
        if (map && map.TopoEditorController) {
            return super.addTo(map.TopoEditorController);
        }
        return null;
    }

    /**
     * 添加到控制器时调用，执行数据的初始化
     * @param {object} controller 控制器实例
     */
    onAdd(controller) {
        super.onAdd(controller);

        this._map = controller.map;
    }

    /**
     * 从控制器中删除时调用，执行数据清理
     */
    onRemove() {
        this.stop();
        
        this._toolMap = null;
        this._map = null;

        super.onRemove();
    }

    /**
     * 绑定工具构造器
     * @param {string} toolKey         工具标识
     * @param {object} toolConstructor 工具构造器
     */
    bindTool(toolKey, toolConstructor) {
        this._toolMap[toolKey] = toolConstructor;
    }

    /**
     * 解绑工具构造器
     * @param {string} toolKey 工具标识
     */
    unbindTool(toolKey) {
        delete this._toolMap[toolKey];
    }

    /**
     * 批量绑定工具构造器
     * @param {object} toolMap 工具构造器映射map
     */
    bindTools(toolMap) {
        if (Util.isObject(toolMap)) {
            for (const [key, val] of Object.entries(toolMap)) {
                this.bindTool(key, val);
            }
        }
    }

    /**
     * 启动编辑工具
     * @param {string} toolKey      绑定到TopoEditor中的工具键值
     * @param {object} toolData     工具的初始化数据
     * @param {object} toolOptions  工具可选项
     */
    start(toolName, toolData, toolOptions) {
        this._controller.startEditor(this);
        this._status = 1; // active

        const tool = this._getTool(toolName, toolOptions);
        if (!tool) {
            return false;
        }

        tool.addTo(this._map);

        tool.onFinish = this.finish;

        // 必须先添加到地图上，然后再初始化
        if (tool.initialize) {
            tool.initialize(toolData);
        }

        this.activeTool = tool;

        this._status = 2; // running

        return true;
    }

    _getTool(toolKey, toolOptions) {
        const ToolConstructor = this._toolMap[toolKey];
        if (ToolConstructor) {
            return new ToolConstructor(toolOptions);
        }
        return null;
    }

    /**
     * 停止编辑器
     */
    stop() {
        if (this.activeTool) {
            this.activeTool.remove();
        }

        this._status = 3; // stopped
    }

    /**
     * 编辑结束时要调用的方法
     */
    finish = editResult => {
        // this.stop();

        if (Util.isFunction(this.onFinish)) {
            this.onFinish(editResult);
        }
    };
}
